import {
    ChangeDetectionStrategy,
    Component,
    computed,
    contentChild,
    input,
} from '@angular/core';
import type { Maybe } from '@quipex/core/primitives';
import type { ContextFamily } from '@quipex/shared/utils';
import { QpxAvatar } from '../avatar';

@Component({
    selector: 'qpx-nav-hero-item',
    imports: [QpxAvatar],
    templateUrl: './nav-hero-item.html',
    styleUrl: './nav-hero-item.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    host: {
        class: 'nav-hero-item',
        role: 'group',
        'aria-label': 'Navigation hero item',
    },
})
export class NavHeroItem {
    //#region Inputs
    public readonly identifier = input.required<string>();
    public readonly imageUrl = input<Maybe<string>>();
    public readonly initials = input<Maybe<string>>();
    public readonly fallbackIcon = input<Maybe<string>>();
    public readonly line1 = input.required<string>();
    public readonly line2 = input<Maybe<string>>();
    public readonly context = input<ContextFamily>();
    //#endregion

    //#region Template references
    protected readonly content = contentChild('actions');
    //#endregion

    //#region State
    protected readonly hasContent = computed(() => !!this.content());
    //#endregion
}
